import { PageLoading } from 'components/loading'
import { css } from 'emotion'
import React from 'react'

export interface ContentCardSectionProps {
  children: React.ReactNode
  isLoading?: boolean
  messageLoading?: string
}

export function ContentCardSection(props: ContentCardSectionProps) {
  return (
    <>
      {props.isLoading && <PageLoading message={props.messageLoading || 'Carregando dados'} />}
      {!props.isLoading && (
        <div
          className={css`
            padding: 0.5rem;
          `}
        >
          {props.children}
        </div>
      )}
    </>
  )
}
